module.exports = __webpack_public_path__ + "static/img/radio_play.7a64ef90.svg";